{
  "markread": "Okundu olarak işaretle",
  "newest": "En yeni",
  "unread": "Okunmayan",
  "starred": "Yıldızlanan",
  "tags": "Etiketler",
  "alltags": "Tüm etiketler",
  "timestamp": "{0,date} {0,time}",
  "hours": "{0, plural,other {#}} saat önce",
  "minutes": "{0, plural,other {#}} dakika önce",
  "seconds": "{0, plural,other {#}} saniye önce",
  "star": "Yıldız ekle",
  "unstar": "Yıldız kaldır",
  "mark": "Okundu olarak işaretle",
  "unmark": "Okunmadı olarak işaretle",
  "load_img": "Resimleri göster",
  "open_window": "Aç",
  "searchbutton": "Ara",
  "sources": "Kaynaklar",
  "source_add": "Kaynak ekle",
  "source_opml": "veya bir OPML dosyasını içe aktar",
  "source_export": "Kaynakları dışa aktar",
  "source_edit": "Düzenle",
  "source_delete": "Sil",
  "source_warn": "Bu kaynak gerçekten silinsin mi?",
  "source_new": "Yeni kaydedilmemiş kaynak",
  "source_title": "Başlık",
  "source_tags": "Etiketler",
  "source_comma": "Virgülle ayrılmış",
  "source_select": "Lütfen kaynak seçin",
  "source_type": "Tür",
  "source_save": "Kaydet",
  "source_cancel": "İptal",
  "source_saved": "Kaydedildi",
  "no_entries": "Yayın bulunmadı",
  "more": "Daha fazla",
  "login": "Oturum aç",
  "login_username": "Kullanıcı adı",
  "login_password": "Parola",
  "no_title": "Başlık yok",
  "article_actions": "Eylemler",
  "close_entry": "Kapat",
  "info_url_copied": "URL panoya kopyalandı.",
  "error_share_native": "Öge paylaşılamıyor.",
  "error_share_native_abort": "Öge paylaşılamıyor — ya hiç paylaşım hedefi yok ya da siz iptal ettiniz.",
  "error_configuration": "Yapılandırma yüklenemiyor.",
  "error_invalid_subsection": "Geçersiz alt bölüm:",
  "error_offline_storage_not_available": "Çevrim dışı depolama kullanılamıyor. Web tarayıcınızın {0}IndexedDB API'sini{1} desteklediğinden ve Google Chrome tabanlı bir tarayıcı kullanıyorsanız selfoss'u gizli modda çalıştırmadığınızdan emin olun.",
  "error_offline_storage": "Çevrim dışı depolama hatası: {0}. Yeniden yüklemek yardımcı olabilir. Çevrim dışı şimdilik devre dışı bırakılıyor.",
  "error_sync": "Sunucudan son değişiklikler eşzamanlanamadı:",
  "error_refreshing_source": "Kaynaklar yenilenemiyor:",
  "error_saving_color": "Yeni renk kaydedilemiyor:",
  "error_loading_stats": "Göz atma istatistikleri yüklenemiyor:",
  "error_loading": "Yükleme hatası:",
  "error_logout": "Oturum kapatılamadı:",
  "error_star_item": "Ögeye yıldız eklenemiyor/yıldızı kaldırılamıyor:",
  "error_mark_item": "Öge işaretlenemiyor/işareti kaldırılamıyor:",
  "error_mark_items": "Tüm görünür ögeler işaretlenemiyor:",
  "error_unknown_source": "Bilinmeyen kaynak kimliği:",
  "error_unknown_tag": "Bilinmeyen etiket:",
  "error_load_tags": "Etiketler yüklenemedi:",
  "error_delete_source": "Kaynak silinemedi:",
  "error_edit_source": "Kaynak değişiklikleri kaydedilemedi:",
  "error_add_source": "Kaynak eklenemedi:",
  "error_session_expired": "Oturumun süresi doldu",
  "app_reload": "Yeniden yükle",
  "app_update": "selfoss güncellendi, lütfen yeniden yükleyin",
  "sources_refreshed": "Kaynaklar yenilendi",
  "reload_list": "Listeyi yeniden yükle",
  "streamerror": "Hiçbir öge yüklenmedi, yeniden yüklensin mi?",
  "error_unwritable_logs": "Günlük yazılamıyor.",
  "error_check_system_logs": "Bir hata oluştu, lütfen sistem günlüklerinize bakın.",
  "error_check_log_file": "Bir hata oluştu, lütfen günlük dosyasına bakın “{0}”.",
  "error": "Bir hata oluştu",
  "login_offline": "Çevrim dışı depolama",
  "login_invalid_credentials": "Yanlış kullanıcı adı/parola",
  "source_refresh": "Bu kaynağı yenile",
  "source_last_post": "Görülen son gönderi",
  "source_pwd_placeholder": "Değişmedi",
  "source_autotitle_hint": "Başlığı almak için boş bırakın",
  "source_filter": "Filtrele",
  "loginbutton": "Oturum aç",
  "logoutbutton": "Oturumu kapat",
  "settingsbutton": "Ayarlar",
  "refreshbutton": "Kaynakları yenile",
  "searchremove": "Aramayı gizle",
  "search_label": "Arama terimi",
  "share_copy_label": "Bağlantıyı panoya kopyala",
  "share_mail_label": "E-posta ile paylaş",
  "share_wordpress_label": "WordPress'te paylaş",
  "share_wallabag_label": "Wallabag'e kaydet",
  "share_pocket_label": "Pocket'a kaydet",
  "share_facebook_label": "Facebook'ta paylaş",
  "share_twitter_label": "Twitter'da paylaş",
  "share_diaspora_label": "Diaspora'da paylaş",
  "share_native_label": "Paylaş",
  "next": "Sonraki",
  "days": "{0,plural,zero {bugün},one {dün},other {# gün önce}}",
  "offline_navigation_unavailable": "Etiketleri ve kaynakları değiştirmek şu anda çevrim dışı modda kullanılamıyor.",
  "offline_count": "Yerel olarak kullanılabilen ögeler",
  "online_count": "Sunucuda bulunan ögeler",
  "filter": "Filtrele",
  "article_reading_time": "{0} dakika okuma",
  "experimental": "Deneysel",
  "source_warn_cancel_dirty": "Kaydedilmemiş değişiklikler atılsın mı?",
  "sources_leaving_unsaved_prompt": "Kaydedilmemiş kaynak değişiklikleri olmasına rağmen ayarlardan çıkılsın mı?",
  "source_browse": "Göz at",
  "source_menu": "Daha fazla eylem",
  "tag_change_color_button_title": "Rengi değiştir",
  "source_go_to_settings": "Ayarlarda aç",
  "sources_loading": "Kaynaklar yükleniyor…",
  "no_sources": "Yapılandırılan kaynak yok.",
  "entries_loading": "Yayınlar yükleniyor…",
  "source_deleting": "Kaynak siliniyor…",
  "login_in_progress": "Oturum açmaya çalışılıyor…",
  "source_params_loading": "Parametreler yükleniyor…",
  "source_saving": "Kaynak değişiklikleri kaydediliyor…",
  "error_unauthorized": "Devam etmek için lütfen {link_begin}oturum açın{link_end}.",
  "login_error_generic": "Oturum açılamadı: {errorMessage}",
  "share_mastodon_label": "Mastodon'da paylaş"
}
